/* eslint-disable react/no-multi-comp */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, memo, SyntheticEvent } from 'react';
import { Flex } from '@rebass/grid';
import { Icon, Link, Text3 } from 'app/shared/ui';

import { TabbedContent } from 'app/shared/components/TabbedContent/TabbedContent';
import { ContentBox } from 'app/shared/components/TabbedContent/ContentBox';
import {
  handleTabsClickTracking,
  scrollBackToTopOfSection,
  toggleSeeMoreInfo,
} from 'app/marketplace/vehicle/Details/utils';
import { useStyledTheme } from 'app/shared/hooks/useStyledTheme';
import { isMobileViewport, scrollToId } from 'app/shared/utils/utils';
import { Remarks } from 'app/marketplace/vehicle/Remarks/Remarks';

import { IDetailsFeaturesTabs } from './DetailsFeaturesTabs.types';
import {
  ErrorMessageSt,
  FlexSt,
  TabWrapperSt,
} from './DetailsFeaturesTabs.css';

export const DetailsFeaturesTabs = memo(
  ({
    breakpoint,
    vehicle,
    extras,
    activeTabs,
    initDescriptionTabOpen,
  }: IDetailsFeaturesTabs): JSX.Element => {
    const [showFullDetails, setShowFullDetails] = useState(false);

    useEffect(() => {
      if (initDescriptionTabOpen)
        scrollToId('d2c-car-features-tabs-4', 100, 200);
    }, []);

    const { colors } = useStyledTheme();
    const isMobile = isMobileViewport(breakpoint);
    const scrollBackToTop = scrollBackToTopOfSection(breakpoint);

    const isPreviewLongerThan5Lines = extras?.comfortListGrouped[0]?.length > 5;

    useEffect(() => {
      setShowFullDetails(!isPreviewLongerThan5Lines);
    }, [breakpoint]);

    const onTabClick = (e: SyntheticEvent, index: number) => {
      handleTabsClickTracking(index, vehicle.id);

      if (!isMobile) {
        e.preventDefault();
        return false;
      }
      return scrollBackToTop(document.querySelector('#car-features-tabs'));
    };

    const onSeeMoreInfoClick = (e: SyntheticEvent) => {
      e.preventDefault();

      toggleSeeMoreInfo(!showFullDetails, isMobile);
      setShowFullDetails(!showFullDetails);
    };

    const getTabTitle = (iconName: string, title: string) => (
      <Flex flexDirection="column">
        <Icon icon={iconName} fontSize={24} my={8} />
        <Text3 fontSize={[14, 12]}>{title}</Text3>
      </Flex>
    );

    const errorMessage = <ErrorMessageSt>Keine Angabe</ErrorMessageSt>;

    const getTabContent = (element: any, index: number) => {
      const content = element;

      if (content.length <= 0) {
        return errorMessage;
      }

      return (
        <>
          <FlexSt
            showFullDetails={index === 0 && isMobile ? showFullDetails : null}
          >
            {content}
          </FlexSt>
          {index === 0 && isMobile && (
            <>
              {isPreviewLongerThan5Lines && (
                <Flex flexDirection="column" alignItems="center" mt={16}>
                  <Link
                    color={colors.mintDark}
                    hoverColor={colors.brandPrimary}
                    onClick={onSeeMoreInfoClick}
                  >
                    <span>
                      {showFullDetails ? 'Weniger anzeigen' : 'Mehr anzeigen'}
                    </span>
                  </Link>
                </Flex>
              )}
            </>
          )}
        </>
      );
    };

    return (
      <TabWrapperSt id="car-features-tabs">
        <TabbedContent
          activeIndex={initDescriptionTabOpen ? 4 : activeTabs}
          activeBgColor={colors.sunbeanSuperLight}
          activeFontColor={colors.actionBlue}
          defaultBgColor="white"
          defaultFontColor={colors.tarmacGrey}
          onClickTab={(e, index) => onTabClick(e, index)}
        >
          <ContentBox
            hasNoContent={!extras.comfortListGrouped.length}
            title={getTabTitle('comfort', 'Komfort')}
            label="Komfort"
          >
            {getTabContent(extras.comfortListGrouped, 0)}
          </ContentBox>

          <ContentBox
            hasNoContent={!extras.extrasListGrouped.length}
            title={getTabTitle('plus', 'Extras')}
            label="Extras"
          >
            {getTabContent(extras.extrasListGrouped, 2)}
          </ContentBox>

          <ContentBox
            hasNoContent={!extras.safetyListGrouped.length}
            title={getTabTitle('safety', 'Sicherheit')}
            label="Sicherheit"
          >
            {getTabContent(extras.safetyListGrouped, 3)}
          </ContentBox>

          <ContentBox
            hasNoContent={!extras.multimediaListGrouped}
            title={getTabTitle('multimedia', 'Multimedia')}
            label="Multimedia"
          >
            {getTabContent(extras.multimediaListGrouped, 4)}
          </ContentBox>
          <ContentBox
            hasNoContent={vehicle.remarks.length === 0}
            title={getTabTitle('page-search', 'Beschreibung')}
            label="Beschreibung"
          >
            {vehicle.remarks.length <= 0 ? (
              errorMessage
            ) : (
              <Remarks remarks={vehicle.remarks} />
            )}
          </ContentBox>
        </TabbedContent>
      </TabWrapperSt>
    );
  },
);
DetailsFeaturesTabs.displayName = 'DetailsFeaturesTabs';
